import React from "react";
import useGlobalInfo from '../useGlobalInfo'
import useGlobalHeader from '../useGlobalHeader'
import useGlobalDisplay from '../useGlobalDisplay'
import useInfoStyle from '../useInfoStyle'
import { UpdateParameterValues } from "../services/City";
function PerformaBreakdown(props) {
  const [value, setValue] = React.useState(null);
  const [ischecked, setchecked] = React.useState(null);
  const [ischecked1, setchecked1] = React.useState(null);
  const [Isinfo, SetIsinfo] = React.useContext(useGlobalInfo);
  const [IsHeader, SetIsHeader] = React.useContext(useGlobalHeader);
  const [IsDisplay, SetIsDisplay] = React.useContext(useGlobalDisplay);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [Isinfostyle, Setinfostyle] = React.useContext(useInfoStyle);
  const [structureType, SetstructureType] = React.useState("Per Home");
  React.useEffect(() => {
    var structuretype = props.structureType;
    if (props.id == 225) {

      if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 287 && item.structureType == props.structureType).value == 'true') {
        document.getElementById("row-" + structuretype + "-198").style.display = "none";
        document.getElementById("row1-" + structuretype + "-198").style.display = "none";
        document.getElementById("row-" + structuretype + "-229").style.display = "none";
        document.getElementById("row-" + structuretype + "-201").style.display = "none";
        // if(structuretype=="Single Family")
        // {
        //   document.getElementById("row-"+structuretype+"-200").style.display = "none";
        // }
        // if(structuretype=="Rowhouse" || structuretype=="Townhome" || structuretype=="Cottage")
        // {
        //   document.getElementById("row-"+structuretype+"-201").style.display = "none";
        // }
        // if(structuretype=="Apartment" || structuretype=="Condo")
        // {
        //   document.getElementById("row-"+structuretype+"-202").style.display = "none";
        // }
      }
      if (props.object["Building Cost Breakdown"].find((item) => item.ParameterId == 288 && item.structureType == props.structureType).value == 'true') {

        document.getElementById("row-" + structuretype + "-110").style.display = "none";
        document.getElementById("row1-" + structuretype + "-110").style.display = "none";
        document.getElementById("row-" + structuretype + "-99").style.display = "none";


        document.getElementById("row-" + structuretype + "-239").style.display = "none";
      }


    }

    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.value == "") {
      //setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.id == 167 || props.id == 143 || props.id == 146) {
      SetStyle("form-control construction leftTop");
    }
    if (props.id == 166) {
      SetStyle("form-control construction RightTop");
    }
    if (props.id == 156 || props.id == 157 || props.id == 158) {
      SetStyle("form-control construction leftBottom");
    }
    if (props.id == 159) {
      SetStyle("form-control construction RightBottom");
    }
    if (props.id == 226) {
      SetStyle("form-control construction leftTop leftBottom");
    }
    if (props.id == 248) {
      SetStyle("form-control construction RightBottom RightTop");
    }
    if (props.id == 181) {
      SetStyle("form-control");
    }
    //let val = props.wholeEl.ischecked.slice(1, props.wholeEl.ischecked.length - 1);

    setchecked(props.wholeEl.ischecked === true ? "checked" : false);
    setchecked1(props.wholeEl.ischecked);
  }, []);
  function setPreviousValue(ID) {
    let e = ID.split('-')[1];

    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    let color1 = document.getElementById("color1").value;
    let color2 = document.getElementById("color2").value;
    let color3 = document.getElementById("color3").value;
    if (previuosID == 187) {
      document.getElementById(StructureType + "-187").style.background = color2;
    }
    if (previuosID == 214) {
      document.getElementById(StructureType + "-214").style.background = color2;
    }
    if (previuosID == 225) {
      document.getElementById(StructureType + "-225").style.background = color2;
    }
  }
  function showInfo(ID) {

    let e = ID.split('-')[1];
    Setinfostyle(ID);
    let StructureType = ID.split('-')[0];
    let previuosID = document.getElementById("PreviousID").value;
    if (previuosID != "" && previuosID != null) {
      setPreviousValue(ID);
    }


    document.getElementById("PreviousID").value = e;

    if (e == 187) {
      document.getElementById("color2").value = document.getElementById(StructureType + "-187").style.backgroundColor;
      document.getElementById(StructureType + "-187").style.background = '#fffce6';
      document.getElementById("HProforma Breakdown" + StructureType).innerText = "Return on Investment";
      document.getElementById("IProforma Breakdown" + StructureType).innerText = "Total Net Profit / Equity Contribution";

      SetIsHeader("Return on Investment");
      SetIsinfo("Total Net Profit / Equity Contribution.");
      SetIsDisplay("info");
    }
    if (e == 214) {
      document.getElementById("color2").value = document.getElementById(StructureType + "-214").style.backgroundColor;
      document.getElementById(StructureType + "-214").style.background = '#fffce6';
      document.getElementById("HProforma Breakdown" + StructureType).innerText = "Return on Cost";
      document.getElementById("IProforma Breakdown" + StructureType).innerText = "Total Net Profit / (Building Cost + Land Cost)";

      SetIsHeader("Return on Cost");
      SetIsinfo("Total Net Profit / (Building Cost + Land Cost).");
      SetIsDisplay("info");
    }
    if (e == 225) {
      document.getElementById("color2").value = document.getElementById(StructureType + "-225").style.backgroundColor;
      document.getElementById(StructureType + "-225").style.background = '#fffce6';
      document.getElementById("HProforma Breakdown" + StructureType).innerText = "Profit Margin After Financing";
      document.getElementById("IProforma Breakdown" + StructureType).innerText = "Total Net Profit / Total Estimated Value";
      SetIsHeader("Profit Margin After Financing");
      SetIsinfo("Total Net Profit / Total Estimated Value.");
      SetIsDisplay("info");
    }

    document.getElementById("Land Analysis" + StructureType).style.display = 'none';
    document.getElementById("Building Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Site Potential" + StructureType).style.display = 'none';
    document.getElementById("Sales Cost Breakdown" + StructureType).style.display = 'none';
    document.getElementById("Proforma Breakdown" + StructureType).style.display = 'block';
  }


  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";


    setchecked(e.target.checked);
    setchecked1(e.target.checked);

    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }

    props.setData({ ...props.wholeEl, value: e.target.value, ischecked: true })

    if (e.target.value != "") {
      UpdateParameterValues(structuretype, props);
      //document.getElementById(e.target.id).value="0";
    }
  };

  const onChange1 = (e) => {
    setchecked(e.target.checked);
    setchecked1(e.target.checked);
    props.setData({ ...props.wholeEl, ...props.wholeEl.ischecked, ischecked: e.target.checked, value: value })


  };


  // if(props.structureType=="Apartment")
  // {
  //   if(props.id==187 || props.id==214 || props.id==225 )
  //   {

  //     return (
  //       <>
  //        <div class="row" style={{width:"103%", marginBottom:"1%"}}> 
  //   <div class="col-md-6"></div>
  //      <div class="col-md-4" >
  //               <div class="from   justify-content-between  align-items-center ">
  //               <label >{props.name.split('Per')[0]}   
  //                </label>



  //             </div>
  //             </div>

  //               <div class="col-md-2">
  //               <div class="from   justify-content-between  align-items-center ">
  //               <div class="test1">
  //               <input
  //                 type="text"
  //                key={props.structureType +"-"+ props.id}
  //                id={props.structureType +"-"+ props.id}
  //                 value={value}
  //                onChange={onChange}
  //                 //placeholder={props.name.split('Per')[0]}
  //                 style={{borderRadius:"5%",backgroundColor:"#ebfae7" ,fontWeight:"550"}}
  //                 class={IsStyle}
  //                 readOnly
  //               />
  //               </div>
  //             </div>
  //             </div>
  //             </div> 
  //       </>
  //     )

  //   }
  //   else{
  //   return (
  //     <>
  //     <div class="col-md-3"></div>
  //             <div class="col-md-3 from   justify-content-between  align-items-center ">
  //             <label >{props.name.split('Per')[0]}   
  //              </label>



  //           </div>
  //             <div class="col-md-3 from   justify-content-between  align-items-center ">
  //             <div class="test">
  //             <input
  //               type="text"
  //              key={props.structureType +"-"+ props.id}
  //              id={props.structureType +"-"+ props.id}
  //               value={value}
  //              onChange={onChange}
  //               //placeholder={props.name.split('Per')[0]}

  //               class={IsStyle}
  //               readOnly
  //             />
  //             </div>
  //           </div>
  //           <div class="col-md-3"></div>
  //     </>
  //   )
  //   }
  // }


  if (props.id == 187 || props.id == 214 || props.id == 225) {
    return (
      <>
        <div class="row" style={{ width: "103%", marginBottom: "1%" }}>
          <div class="col-md-6"></div>
          <div class="col-md-4 col" >
            <div class="from   justify-content-between  align-items-center ">
              <label >{props.name.split('Per')[0]}
                <span class="question" onClick={() => showInfo(props.structureType + "-" + props.id)} > <svg xmlns="http://www.w3.org/2000/svg" width="15.339" height="17" fill="gray" >
                  <path d="M6.749,0A6.749,6.749,0,1,0,13.5,6.749,6.757,6.757,0,0,0,6.749,0Zm0,12.7A5.955,5.955,0,1,1,12.7,6.749,5.961,5.961,0,0,1,6.749,12.7Zm.919-3a.819.819,0,1,1-.819-.819A.82.82,0,0,1,7.669,9.7Zm.8-6.355A1.913,1.913,0,0,1,8.9,4.82,3,3,0,0,1,7.814,6.442,1.6,1.6,0,0,0,7.072,7.75H6.278a2.36,2.36,0,0,1,1-1.9,2.279,2.279,0,0,0,.846-1.214,1.187,1.187,0,0,0-.286-.8,1.2,1.2,0,0,0-.991-.465A1.324,1.324,0,0,0,5.364,4.652L4.57,4.631a2.118,2.118,0,0,1,2.281-2.05,2.017,2.017,0,0,1,1.614.766Z" />
                </svg></span>

              </label>



            </div>
          </div>

          <div class="col-md-2 col-3">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test1">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ borderRadius: "5%", backgroundColor: "#ebfae7", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )

  }

  if (props.id == 146 || props.id == 143 || props.id == 167 || props.id == 166) {

    if (props.id == 146 || props.id == 143 || props.id == 167) {
      return (

        <>
          <div class="col-md-12 input-box1 ">
            <div class="row" style={{ width: "100%" }}>
              <div class="col-md-6"></div>
              <div class="col-md-3 col"><label class="d-block text-center">{structureType}</label></div>
              <div class="col-md-3 col"><label class="d-block text-center">Project</label></div>
            </div></div>
          <div class="col-md-3 col"></div>

          <div class="col-md-3 from   justify-content-between  align-items-center ">
            <label >{props.name.split('Per')[0]}
            </label>



          </div>
          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 125 || props.id == 127 || props.id == 161 || props.id == 182) {
    if (props.id == 125 || props.id == 127 || props.id == 161) {
      return (

        <>
          <div class="col-md-3"></div>
          <div class="col-md-3  from   justify-content-between  align-items-center ">
            <label >{props.name.split('Per')[0]}
            </label>



          </div>
          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 135 || props.id == 137 || props.id == 139 || props.id == 141) {
    if (props.id == 135 || props.id == 137 || props.id == 139) {
      return (

        <>
          <div class="col-md-3"></div>
          <div class="col-md-3 from   justify-content-between  align-items-center ">
            <label >{props.name.split('Per')[0]}
            </label>



          </div>
          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 122 || props.id == 149 || props.id == 151 || props.id == 123) {
    if (props.id == 122 || props.id == 149 || props.id == 151) {
      return (

        <>
          <div class="col-md-3"></div>
          <div class="col-md-3 from   justify-content-between  align-items-center ">
            <label >{props.name.split('Per')[0]}
            </label>



          </div>
          <div class="col-md-3 col from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 153 || props.id == 154 || props.id == 50 || props.id == 155) {
    if (props.id == 153 || props.id == 154 || props.id == 50) {
      return (

        <>
          <div class="col-md-3"></div>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label >{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ backgroundColor: "#ebfae7", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ backgroundColor: "#ebfae7", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 163 || props.id == 164 || props.id == 183 || props.id == 162) {
    if (props.id == 163 || props.id == 164 || props.id == 183) {
      return (

        <>
          <div class="col-md-3"></div>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label >{props.name.split('Per')[0]}
              </label>



            </div>
          </div>

          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}

                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 156 || props.id == 157 || props.id == 158 || props.id == 159) {
    if (props.id == 156 || props.id == 157 || props.id == 158) {
      return (

        <>
          <div class="col-md-3"></div>
          <div class="col-md-3" >
            <div class="from   justify-content-between  align-items-center ">
              <label ><u>{props.name.split('Per')[0]}  </u>
              </label>



            </div>
          </div>

          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ backgroundColor: "#ebfae7", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col">
            <div class="from   justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  //placeholder={props.name.split('Per')[0]}
                  style={{ backgroundColor: "#ebfae7", fontWeight: "550" }}
                  class={IsStyle}
                  readOnly
                />
              </div>
            </div>
          </div>
          <div class="row" style={{ width: "100%" }}>
            <div class="col-md-3"></div>
            <div class="col-md-9" style={{ marginTop: "5%", marginBottom: "5%", borderTop: "1px solid rgba(0, 0, 0, 0.2)" }}></div>
          </div>
        </>
      );


    }

  }
  else {

    return (
      <>
        <div class="col-md-3 col">
          <div class="from   justify-content-between  align-items-center ">
            <label >{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-3 col">
          <div class="from   justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                //placeholder={props.name.split('Per')[0]}

                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default PerformaBreakdown;
